const SETTINGS = {
  // id for portal container (we will dynamically load elements in this element)
  PORTAL_ID: 'ontruck-portal',
  // local storage key for persisting filters between pages
  FILTERS_LOCAL_STORAGE_KEY: 'emergencies-filters-smart-cache-2',
  // time between reloads
  RELOAD_TICKETS_LIST_INTERVAL_IN_SECONDS: 30,
  TICKETS_LIST_PAGE_SIZE: 25,
  TICKETS_TABLE_COLUMN_SIZES_IN_PX: {
    TICKET: '120px',
    SHIPPER: '200px',
    LOCATIONS: '360px',
    SERVICE: '180px',
    CARRIER: '150px',
    QUOTE: '110px',
    REQUIREMENTS: '140px',
    OWNER: '120px',
    INTERNAL_COMMENT_BUTTON: '60px',
    INTERNAL_COMMENT_MESSAGE: '140px',
    ACTIONS: '24px',
  },
  ALERTS_PAGE_SIZE: 20,
  NEW_TICKET_NOTIFICATIONS_POLLING_INTERVAL_IN_SECONDS: 5,
  NEW_TICKET_NOTIFICATIONS_PAGE_SIZE: 3,
  ALERTS_NOTIFICATION_REFRESH_INTERVAL: 10000,
  FILTER_VIEWS_TABLE_COLUMN_SIZES_IN_PX: {
    NAME: '80%',
    RATING: '20%',
  },
};

export default SETTINGS;
